import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import checked from '../../../../../assets/images/icons/checked/checked-gradient.svg';

export const useStyles = makeStyles(({
  breakpoints, fontSizes, fontWeights, palette }: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '0.75rem',
    border: `1px solid ${palette.grey[400]}`,
    borderRadius: '1rem',
    [breakpoints.up('lg')]: {
      alignItems: 'flex-start',
      padding: '1.5rem',
      borderRadius: '0.5rem',
    },
  },
  reverse: {
    '&&': {
      [breakpoints.up('lg')]: {
        flexDirection: 'column-reverse',
        justifyContent: 'flex-end',
      },
    },
  },
  row: {
    '&&': {
      [breakpoints.up('lg')]: {
        flexDirection: 'row',
      },
      '& > img': {
        [breakpoints.up('lg')]: {
          width: 'calc(47% - 0.5rem)',
        },
      },
      '& > div': {
        [breakpoints.up('lg')]: {
          width: 'calc(53% - 0.5rem)',
        },
      },
    },
  },
  rowReverse: {
    '&&': {
      [breakpoints.up('lg')]: {
        flexDirection: 'row-reverse',
      },
      '& > img': {
        [breakpoints.up('lg')]: {
          width: 'calc(47% - 0.5rem)',
        },
      },
      '& > div': {
        [breakpoints.up('lg')]: {
          width: 'calc(53% - 0.5rem)',
        },
      },
    },
  },
  wide: {
    [breakpoints.up('lg')]: {
      width: 'calc(58.7% - 0.375rem)',
    },
  },
  narrow: {
    [breakpoints.up('lg')]: {
      width: 'calc(41.3% - 0.375rem)',
    },
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
  title: {
    margin: 0,
    fontSize: '1.5rem',
    fontWeight: fontWeights.medium,
    lineHeight: 1.2,
    [breakpoints.up('xl')]: {
      fontSize: fontSizes.xxl,
      lineHeight: 1.3,
    },
  },
  iconWrapper: {
    lineHeight: 0,
  },
  smallMobile: {
    height: '11rem',
    overflow: 'hidden',
    borderRadius: '1rem',
    '& img': {
      marginTop: '-2rem',
      [breakpoints.up('sm')]: {
        marginTop: 'unset',
      },
    },
    [breakpoints.up('sm')]: {
      height: 'unset',
    },
  },
  icon: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    borderRadius: '1rem',
    [breakpoints.up('lg')]: {
      borderRadius: 0,
    },
  },
  font: {
    margin: 0,
    fontSize: '0.875rem',
    lineHeight: 1.3,
    [breakpoints.up('xl')]: {
      fontSize: '1rem',
      lineHeight: 1.4,
    },
  },
  list: {
    listStyle: 'none',
    padding: '0',
    '& li': {
      position: 'relative',
      minHeight: '1.25rem',
      marginBottom: '0.5rem',
      paddingLeft: '1.75rem',
      background: `no-repeat url(${checked}) left top`,
      backgroundSize: '1.25rem',
    },
    '& li:last-child': {
      marginBottom: 0,
    },
  },
  nowrap: {
    whiteSpace: 'nowrap',
  },
}));
